export default {
  corretora: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // {{NEXT}}
}
